/**
 * Neutral initials tile (Design Specification Section 3.5). Replaces the earlier
 * colored-tile-plus-icon treatment: admin-entered provider.color values are
 * unvalidated and can fail contrast, and a colored icon tile reads as a real
 * company logo we do not have permission to show. Real supplier logos are added
 * only after Witherspoon-CLO confirms licensing.
 */
export default function ProviderLogo({ provider, size = 48 }) {
  if (!provider) return null;
  const dim = `${size}px`;
  const initials = (provider.name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  return (
    <div
      className="flex items-center justify-center rounded-xl shrink-0"
      style={{ width: dim, height: dim, backgroundColor: "var(--rc-surface-alt)" }}
      data-testid={`provider-logo-${provider.slug}`}
      aria-hidden="true"
    >
      <span
        className="font-display"
        style={{ fontSize: size * 0.36, color: "var(--rc-ink)", letterSpacing: "-0.01em" }}
      >
        {initials}
      </span>
    </div>
  );
}
